export default __webpack_public_path__ + "static/splash-2-9be351ddff3f69c9da29ca48faf35ae9.png";